import { IStepLayoutConf } from '../types/steps';

export const stepsLayoutConf: IStepLayoutConf[] = [
  { step: '1', subSteps: [{ step: 'a' }, { step: 'b' }, { step: 'c' }] },
  { step: '2', subSteps: [{ step: 'a' }, { step: 'b' }] },
  { step: '3', subSteps: [] },
  { step: '4', subSteps: [] },
  { step: '5', subSteps: [] },
];
